import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './automotive.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import automotiveTopCar from '../../assets/automotive-top-car.png';
import automotiveMidBanner from '../../assets/automotive-mid-banner.png';
import { sendContactEmail } from '../../utils/emailjs';

const Automotive = () => {
  const navigate = useNavigate();
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  const handleNavigateToInquiryForm = () => {
    navigate('/sell-your-business#kw-sell-inquiry');
  };

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Automotive Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__automotive-page">
      <section className="kw__automotive-top">
        <div className="kw__automotive-top-inner kw__automotive-section">
          <p className="kw__automotive-outline">Automotive</p>

          <div className="kw__automotive-hero-copy">
            <h1>Scaling Strategic Distribution, Securing High-Demand Assets</h1>
            <p>
              The automotive sector thrives on market demand, reliable supply, and efficient distribution. We specialize in the strategic acquisition
              and retail management of premium passenger vehicles and in-demand automotive platforms. By leveraging strong regional dealer
              relationships, market data, and volume buying power, we secure high-value automotive inventory to meet the evolving demands of
              individual buyers and corporate fleets alike.
            </p>
          </div>
        </div>

        <img src={automotiveTopCar} alt="" className="kw__automotive-top-car" aria-hidden="true" />
      </section>

      <section className="kw__automotive-black-band">
        <div className="kw__automotive-section kw__automotive-black-inner">
          <h2>Market Demand Managed - Procurement &amp; Value Optimization</h2>
          <p>
            We master the complexities of the modern automotive retail landscape, where vehicle supply chains and market pricing shift rapidly.
            Managing structured vehicle inspections, inventory logistics, and competitive asset pricing requires absolute operational discipline. Our
            streamlined procurement frameworks ensure that our retail portfolio remains optimized with vehicles that deliver long-term reliability
            and strong resale performance.
          </p>
        </div>
      </section>

      <section className="kw__automotive-scale kw__automotive-section">
        <h2>Driving Commercial Scale Across the Automotive Sector</h2>
        <p>
          Successful automotive retail relies on a dependable pipeline of quality vehicles that align with consumer expectations and market trends.
          Our focus remains on expanding our automotive footprint while maintaining rigorous standards of quality assurance and corporate
          transparency. We ensure consistent inventory turnover, reliable vehicle sourcing, and seamless transactional execution. This commercial
          platform is purpose-built for trade partners, corporate fleet clients, and automotive professionals who understand that retail scale only
          succeeds when procurement is efficient and consistent.
        </p>
      </section>

      <section className="kw__automotive-mid-banner-wrap" aria-hidden="true">
        <img src={automotiveMidBanner} alt="" className="kw__automotive-mid-banner" />
      </section>

      <section className="kw__automotive-cta">
        <div className="kw__automotive-section kw__automotive-cta-inner">
          <h2>Ready to Scale Your Automotive Portfolio?</h2>
          <p>
            If you are looking to source high-demand vehicle inventory, partner on fleet procurement, or join a fast-growing automotive network,
            join our team and let&apos;s drive the market forward together.
          </p>
          <button type="button" className="kw__automotive-cta-btn" onClick={handleNavigateToInquiryForm}>
            <span>Let&apos;s Connect to Discuss</span>
            <img src={buttonArrow} alt="" />
          </button>
        </div>
      </section>

      <section className="kw__automotive-newsletter kw__automotive-section">
        <div className="kw__automotive-news-copy">
          <p className="kw__automotive-news-label">Newsletter</p>
          <h3>Never Miss an Update</h3>
          <p>
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to
            your inbox.
          </p>
        </div>

        <form className="kw__automotive-news-form" onSubmit={handleSubmit}>
          <div className="kw__automotive-news-row">
            <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleChange} />
            <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleChange} />
          </div>
          <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleChange} />
          <button type="submit" className="kw__automotive-news-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>
      </section>
    </div>
  );
};

export default Automotive;
